import React from 'react';
import { connect } from 'react-redux';
import { Actions as FSSREPORTACTIONS } from '../../store/actions/fssReportActions';
import { XMarkIcon } from '@heroicons/react/20/solid';

const RegenerateFormsModal = ({
    modalStatus,
    openRegenerateFormsModal,
    year,
    downloadFSSReport,
    downloading,
    regenerating,
    regenerateFSSReports,
}) => {

    if(!modalStatus) return <></>;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{display: "block",background: "rgba(0,0,0,0.4)",overflow:"scroll"}}>
            <div className="modal-dialog">
                <div className="modal-content" >
                    <div className="block block-themed block-transparent remove-margin-b">
                        <div className="block-header bg-danger">
                            <ul className="block-options">
                                <li>
                                    <button className="close" type="button" aria-label="Close" onClick={() => openRegenerateFormsModal({ status: false })}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                </li>
                            </ul>
                            <h3 className="block-title">Regenerate FS3s & FS7</h3>
                        </div>
                        <div className="modal-body">
                            <div className="clearfix" />
                                WARNING: By regenerating Tax Forms, you will be updating all of the FS3s, the FS7 and the submission files for the year based on the latest data. This cannot be undone. You are advised to download an offline copy of any existing documents you will need.
                            <div className="clearfix" /> <br/>
                            <div className="row">
                                <div className="col-xs-12 text-right">
                                    <button disabled={regenerating} className="btn btn-danger pull-right" type="button" id="regenerate-forms-btn" style={{ marginLeft: 10 }} onClick={() =>  regenerateFSSReports({ year })}>{regenerating ? "Regenerating Forms..." : "Regenerate Forms"}</button>
                                    <button disabled={downloading} className="btn btn-default pull-right" type="button" id="download-forms-btn"
                                    onClick={() =>  {
                                        ["fs3", "fs7"].map(r => {
                                            downloadFSSReport({
                                                name: r,
                                                year,
                                                employee: r === "fs3" ? "all" : null,
                                            });
                                        })
                                    }}>{downloading ? "Downloading..." : "Download Forms"}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    const { status: modalStatus, year, regenerating } = state.fssRegenerateModal || {};
    return {
        modalStatus,
        year,
        downloading: state.fssDownloading && Object.keys(state.fssDownloading).some(o => state.fssDownloading[o]),
        regenerating,
    };
};

const mapDispatchToProps = (dispatch) => ({
    downloadFSSReport: (data) => dispatch(FSSREPORTACTIONS.downloadFSSReport(data)),
    openRegenerateFormsModal: ({ status }) => dispatch(FSSREPORTACTIONS.openRegenerateFormsModal({ status })),
    regenerateFSSReports: ({ year }) => dispatch(FSSREPORTACTIONS.regenerateFSSReports({ year })),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegenerateFormsModal);